import React from 'react';
import { useFieldArray, useFormContext } from 'react-hook-form';
import FormInput from 'components/shared/BWFormControl/FormInput';
import { Empty } from 'antd';

export default function IpAddress({ isEdit = true }) {
  const methods = useFormContext();
  const { control, getValues } = methods;
  const { fields, append, remove } = useFieldArray({
    control,
    name: 'ips',
  });

  const handleDeleteRow = (idx) => {
    remove(idx);
  };

  const handleAddRow = () => {
    const ips = getValues('ips') ?? [];
    const hasBlankRow = ips.some((item) => !`${item?.ip_name || ''}`.trim() && !`${item?.ip_address || ''}`.trim());
    if (hasBlankRow) return;

    append({
      ip_name: '',
      ip_address: '',
      is_ipv4: 1,
    });
  };

  return (
    <>
      {isEdit && (
        <div style={{ display: 'flex', flexDirection: 'row-reverse', marginBottom: '1em' }}>
          <button type='button' onClick={handleAddRow} className='bw_btn_outline bw_btn_outline_success'>
            <span className='fi fi-rr-plus'></span> Thêm địa chỉ
          </button>
        </div>
      )}
      <div className='bw_table_responsive'>
        <table className='bw_table'>
          <thead>
            <tr>
              <th className='bw_sticky bw_check_sticky bw_text_center'>STT</th>
              <th className='bw_text_center'>Tên địa chỉ IP</th>
              <th className='bw_text_center'>Địa chỉ IP</th>
              <th className='bw_text_center'>Là IPV4</th>
              {isEdit && <th className='bw_sticky bw_action_table bw_text_center'>Thao tác</th>}
            </tr>
          </thead>
          <tbody>
            {fields.length ? (
              fields.map((ip, i) => (
                <tr key={ip.id}>
                  <td className='bw_sticky bw_check_sticky bw_text_center'>{i + 1}</td>
                  <td className='bw_text_center'>
                    <FormInput
                      disabled={!isEdit}
                      className='bw_inp bw_mw_2 bw_text_center'
                      field={`ips.${i}.ip_name`}
                      placeholder='Tên địa chỉ'
                      validation={{
                        validate: (value) => {
                          const ipAddress = `${getValues(`ips.${i}.ip_address`) || ''}`.trim();
                          if (!ipAddress && !`${value || ''}`.trim()) return true;
                          return `${value || ''}`.trim() ? true : 'Tên địa chỉ IP là bắt buộc';
                        },
                      }}
                    />
                  </td>
                  <td className='bw_text_center'>
                    <FormInput
                      disabled={!isEdit}
                      className='bw_inp bw_mw_2 bw_text_center'
                      field={`ips.${i}.ip_address`}
                      placeholder='Địa chỉ'
                      validation={{
                        validate: (value) => {
                          const ipName = `${getValues(`ips.${i}.ip_name`) || ''}`.trim();
                          const ipAddress = `${value || ''}`.trim();
                          if (!ipName && !ipAddress) return true;
                          if (!ipAddress) return 'Địa chỉ IP là bắt buộc';
                          if (getValues(`ips.${i}.is_ipv4`) && !/^(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}$/.test(ipAddress)) {
                            return 'Địa chỉ IPv4 không hợp lệ';
                          }
                          return true;
                        },
                      }}
                    />
                  </td>
                  <td className='bw_text_center'>
                    <label
                      style={{
                        marginRight: '0px',
                      }}
                      className='bw_checkbox'>
                      <FormInput disabled={!isEdit} type='checkbox' field={`ips.${i}.is_ipv4`} />
                      <span></span>
                    </label>
                  </td>
                  {isEdit && (
                    <td className='bw_sticky bw_action_table bw_text_center'>
                      <button type='button' onClick={() => handleDeleteRow(i)} className='bw_btn_table bw_delete bw_red'>
                        <i className='fi fi-rr-trash'></i>
                      </button>
                    </td>
                  )}
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={isEdit ? 5 : 4}>
                  <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description='Không tìm thấy dữ liệu' />
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </>
  );
}
